import React from 'react';
import { HTMLTrans } from '../Common/Translations';

const PromotionGroupPackage = (props) => {
  const {
    promotions,
    totalSellingPrice,
    totalOriginalPrice,
    totalDiscountPercentage,
    store: {
      currency: {
        code
      }
    }
  } = props;
  
  return (
    <div>
      <p className="ProximaNova-Bold mb-0"><HTMLTrans id="promotion.promotiongrouppackage_title">PACKAGE INCLUDES:</HTMLTrans></p>
      <ul className="mb-1">
        {promotions.map((promotion) => (
          <li key={promotion.id}>{promotion.name}</li>
        ))}
      </ul>
      <div className='promotion-group__pricing mt-2'>
        <span className='promotion-group__pricing--sell'>
          {code} {totalSellingPrice}
        </span>
        <span className='promotion-group__pricing--original'>
          {code} {totalOriginalPrice}
        </span>
        <span className='promotion-group__pricing--discount'>
          {totalDiscountPercentage}%
          {additionalDiscount(promotions[0].price.additionalDiscountPercentage)}
          &nbsp;OFF
        </span>
      </div>
    </div>
  )};

const additionalDiscount = (additionalDiscountPercentage) => {
  if (additionalDiscountPercentage > 0) {
    return ` + ${additionalDiscountPercentage}%`;
  }
};

export default PromotionGroupPackage;


// WEBPACK FOOTER //
// ./src/Promotion/PromotionGroupPackage.js